//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";
import Zoom from "@material-ui/core/Zoom";
import Grow from "@material-ui/core/Grow";

//......keep this import at last......
import { useStyles } from "../Styles";

export default function ImageCarousel() {
  const classes = useStyles();
  const [open, toggleOpen] = React.useState(false);
  const [current, setCurrent] = React.useState(0);
  const [slides, setSlides] = React.useState([]);
  const [startCarousel, triggerCarousel] = React.useState(false);
  // var onWindows = React.useState("");
  // onWindows = /Windows/i.test(navigator.userAgent);
  var normalScreen = React.useState(Boolean);
  // normalScreen = window.matchMedia("(min-width: 769px)").matches;
  normalScreen = window.matchMedia("(min-width: 1350px)").matches;

  var mobileScreen = React.useState(Boolean);
  // mobileScreen = window.matchMedia("(max-width: 768px)").matches;
  mobileScreen = window.matchMedia("(max-width: 1349px)").matches;

  const [slidesH] = React.useState([
    "images/introduction/bg1.jpg",
    "images/introduction/bg2.jpg",
    "images/introduction/bg3.jpg",
    "images/introduction/bg4.jpg",
    "images/introduction/bg5.jpg",
    "images/introduction/bg6.jpg",
    "images/introduction/bg7.jpg",
    "images/introduction/bg8.jpg",
  ]);
  const [slidesV] = React.useState([
    "images/introduction/bgV/bg1.jpg",
    "images/introduction/bgV/bg2.jpg",
    "images/introduction/bgV/bg3.jpg",
    "images/introduction/bgV/bg4.jpg",
    "images/introduction/bgV/bg5.jpg",
    "images/introduction/bgV/bg6.jpg",
    "images/introduction/bgV/bg7.jpg",
    "images/introduction/bgV/bg8.jpg",
  ]);
  var onlongtouch;
  var timer;
  React.useEffect(() => {
    // console.log("mobile screen: ", mobileScreen);
    // console.log("normal screen: ", normalScreen);
    // console.log("media screen is: ", window.styleMedia);
    setCarousel();
    // document.oncontextmenu = function (e) {
    //   if (e.button === 2) {
    //     window.alert(
    //       "Hey!! Right click is disabled!"
    //     );
    //     e.preventDefault();
    //     return false;
    //   }
    // };
    // document.ondragstart = function (e) {
    //   window.alert(
    //     "Where you want to drag this image to? Drag feature is disabled!"
    //   );
    //   e.preventDefault();
    //   return false;
    // };

    // document.ontouchstart = function (e) {
    //   if (!timer) {
    //     timer = setTimeout(onlongtouch, 440);
    //   }
    // };
    // document.ontouchend = function (e) {
    //   if (timer) {
    //     clearTimeout(timer);
    //     timer = null;
    //   }
    // };
    // document.ontouchmove = function (e) {
    //   clearTimeout(timer);
    //   timer = null;
    // };

    if (startCarousel) {
      const next = (current + 1) % slides.length;
      const id = setTimeout(() => setCurrent(next), 2300);
      return () => clearTimeout(id);
    }
  }, [current, slides, startCarousel]);

  // onlongtouch = function () {
  //   timer = null;
  //   window.alert("Hey!! long press is disabled.");
  // };

  const setCarousel = () => {
    if (normalScreen) {
      // console.log("showing elements for normal screen");
      slides.push(...slidesH);
      triggerCarousel(true);
    } else {
      // console.log("showing elements for mobile screen");
      slides.push(...slidesV);
      triggerCarousel(true);
    }
  };
  return (
    <React.Fragment>
      <Zoom in={true} style={{ transitionDelay: true ? "500ms" : "0ms" }}>
        <img
          id="carousel"
          src={slides[current]}
          className={
            normalScreen ? classes.carousel : classes.carouselSmallScreen
          }
          alt=""
        ></img>
      </Zoom>

     

    </React.Fragment>
  );
}
